import { render, staticRenderFns } from "./PayUButton.vue?vue&type=template&id=33ad8010"
import script from "./PayUButton.vue?vue&type=script&lang=js"
export * from "./PayUButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports